export default __webpack_public_path__ + "images/cc7f0e1702292ad8aef3ab1bf6d4a915.svg";